import { TenderSearchVendorsResponse } from '@Types/api/form/tenderRequest/TenderSearchVendorsResponse';
import { TenderSubmitRequest } from '@Types/api/form/tenderRequest/TenderSubmitRequest';
import { TypeDict } from '@Types/index';
import dayjs from 'dayjs';

export interface InitiateForm {
  startDate: string;
  endDate: string;
  purchaseFor: 'Order' | 'Submittal';
  tenderComments: string;
  tenderMode: 'Auto' | 'Manual';
  selectedVendors: TenderSearchVendorsResponse[];
}

export const mapInitiateFormData = (
  formData: InitiateForm,
  prForDict: TypeDict[],
  tenderModeDict: TypeDict[]
): Omit<TenderSubmitRequest, 'requestId'> => {
  const vendorIds = formData.selectedVendors.map(({ vendorId }) => vendorId);
  const tenderSentDate = formData.startDate;
  const tenderExpiryDate = dayjs(formData.endDate)
    .utc()
    .hour(6)
    .minute(0)
    .second(0)
    .millisecond(0)
    .toISOString();
  const prFor = prForDict.find(
    (dictItem) => dictItem.codeDesc === formData.purchaseFor
  )!.codeNum;
  const tenderMode = tenderModeDict.find(
    (dictItem) => dictItem.codeDesc === formData.tenderMode
  )!.codeNum;

  return {
    vendorIds,
    tenderSentDate,
    tenderExpiryDate,
    prFor,
    tenderComments: formData.tenderComments,
    tenderMode,
  };
};
